import {message} from 'antd';
import {CheckCircle, XCircle} from 'phosphor-react';
import './index.less';

message.config({
	maxCount: 1
});

const toast = ({text, type}: {text: string; type: 'success' | 'error'}) => {
	message.open({
		key: 'toast',
		type,
		content: text,
		icon:
			type === 'success' ? (
				<CheckCircle color="#002494" size={55} weight="fill" />
			) : (
				<XCircle color="#CE1126" size={55} weight="fill" />
			),
		className: 'toast',
		duration: type === 'success' ? 1 : 5,
		onClick: () => {
			message.destroy('toast');
		}
	});
};

export default {
	success: (text: string) => toast({type: 'success', text}),
	error: (text: string) => toast({type: 'error', text})
};
